export default {
    methods: {
        triggerEventGA(action, payload) {
            payload['user_IP'] = $('input[name="ip"]').val();
            payload['map_id'] = $('input[name="map_id"]').val();
            payload['datetime'] = Date.now();
            gtag('event', action, payload);
        }
    }
}